import { useState, useRef, useCallback } from 'react';
import { Option } from '@spike/model';
import Button from 'components/UI/V3/Button/Button';
import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import MultipleListContent from 'components/UI/V3/MultipleSelector/MultipleListContent';
import SelectorListContainer from 'components/UI/V3/MultipleSelector/SelectorListContainer';
import ClickAwayListener from 'react-click-away-listener';
import styles from './BoardingServiceMultipleSelector.module.scss';

interface BoardingServiceMultipleSelectorProps<T> {
    options: Array<Option<T>>;
    selectedIds: Array<T>;
    allOptionLabel?: string;
    enableSearch?: boolean;
    onChange?: (selectedIds: Array<T>) => void;
}

export const BoardingServiceMultipleSelector = <T,>(props: BoardingServiceMultipleSelectorProps<T>) => {
    const [expanded, setExpanded] = useState(false);
    const selectedIdsRef = useRef<Array<T>>(props.selectedIds);
    selectedIdsRef.current = props.selectedIds;

    const handleChange = useCallback(
        (newSelectedIds: Array<T>) => {
            const current = selectedIdsRef.current;
            const isDifferent =
                newSelectedIds.length !== current.length || newSelectedIds.some(id => !current.includes(id));

            if (isDifferent) {
                props.onChange?.(newSelectedIds);
            }
        },
        [props.onChange]
    );

    return (
        <div className={styles.container}>
            <Button
                label=""
                leftIcon={faPlus}
                variant="outlined"
                size="medium"
                onClick={() => setExpanded(true)}
                className={styles.triggerButton}
            />
            {expanded && (
                <ClickAwayListener onClickAway={() => setExpanded(false)}>
                    <div className={styles.dropdown}>
                        <SelectorListContainer className={styles.listContainer}>
                            <MultipleListContent
                                options={props.options}
                                selectedIds={props.selectedIds}
                                allOptionLabel={props.allOptionLabel}
                                enableSearch={props.enableSearch}
                                onChange={handleChange}
                            />
                        </SelectorListContainer>
                    </div>
                </ClickAwayListener>
            )}
        </div>
    );
};

export default BoardingServiceMultipleSelector;
